export default "__VITE_ASSET__DTHStZ4l__"